import { C } from "../../lib/constants";

export const Card = ({children, style}) => (
  <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:16,marginBottom:14,boxShadow:"0 2px 10px rgba(0,0,0,.04)",...style}}>
    {children}
  </div>
);
